import { Directive, ElementRef, HostListener, Input } from '@angular/core';

export const AVATAR_PLACEHOLDER = 'assets/avatar-placeholder.svg';

/**
 * Swaps an <img> to a local placeholder when its source fails to load
 * (e.g. avatars on cdn.goodgame66.com, which currently serves a wrong certificate).
 * Usage: <img [src]="item.image | imgHost" appImgFallback>  or  appImgFallback="assets/other.png"
 */
@Directive({
  selector: 'img[appImgFallback]',
})
export class ImgFallbackDirective {
  @Input() appImgFallback = '';

  constructor(private ngEl: ElementRef<HTMLImageElement>) {}

  @HostListener('error')
  onError() {
    const img = this.ngEl.nativeElement;
    const fallback = this.appImgFallback || AVATAR_PLACEHOLDER;
    // guard against a loop when the fallback itself cannot load
    if (img.getAttribute('src') === fallback) {
      return;
    }
    img.src = fallback;
  }
}
